// VoiceButton.js
import React, { useState, useCallback, useEffect } from "react";
import {
  BackgroundEffect,
  ButtonWrapper,
  MicStream,
  PauseStream,
  // Tooltip,
  Box,
  Text,
  PulseWrapper,
  LoaderContainer,
  MicDisabled
} from "./VoiceButtonStyles";
import StartStreamIcon from "@images/chatvoice/micro-icon.svg";
import PauseStreamIcon from "@images/chatvoice/pause-stream.svg";
import DisabledVoice from "@images/chatvoice/disabled_voice.svg";

// Custom SVG Loader
const CustomLoader = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9993 0.666992C14.353 0.666992 14.6921 0.807468 14.9422 1.05752C15.1922 1.30756 15.3327 1.6467 15.3327 2.00033V6.00033C15.3327 6.35395 15.1922 6.69309 14.9422 6.94313C14.6921 7.19318 14.353 7.33366 13.9993 7.33366C13.6457 7.33366 13.3066 7.19318 13.0565 6.94313C12.8065 6.69309 12.666 6.35395 12.666 6.00033V2.00033C12.666 1.6467 12.8065 1.30756 13.0565 1.05752C13.3066 0.807468 13.6457 0.666992 13.9993 0.666992ZM23.4287 4.57099C23.6786 4.82103 23.8191 5.16011 23.8191 5.51366C23.8191 5.86721 23.6786 6.20629 23.4287 6.45633L20.602 9.28433C20.352 9.53451 20.0128 9.67514 19.6592 9.67526C19.3055 9.67539 18.9662 9.535 18.716 9.28499C18.4658 9.03498 18.3252 8.69582 18.3251 8.34213C18.325 7.98844 18.4653 7.64918 18.7153 7.39899L21.5434 4.57099C21.7934 4.32103 22.1325 4.18061 22.486 4.18061C22.8396 4.18061 23.1786 4.32103 23.4287 4.57099ZM4.57268 4.57366C4.82272 4.3237 5.1618 4.18328 5.51535 4.18328C5.8689 4.18328 6.20798 4.3237 6.45802 4.57366L9.28868 7.40433C9.41603 7.52732 9.51761 7.67445 9.58748 7.83712C9.65736 7.99979 9.69414 8.17475 9.69568 8.35179C9.69722 8.52883 9.66349 8.7044 9.59644 8.86826C9.5294 9.03213 9.4304 9.181 9.30521 9.30619C9.18002 9.43138 9.03115 9.53038 8.86729 9.59742C8.70343 9.66446 8.52785 9.6982 8.35081 9.69666C8.17378 9.69512 7.99882 9.65834 7.83614 9.58846C7.67347 9.51858 7.52634 9.41701 7.40335 9.28966L4.57268 6.45899C4.32272 6.20896 4.1823 5.86988 4.1823 5.51633C4.1823 5.16277 4.32272 4.8237 4.57268 4.57366ZM0.666016 14.0003C0.666016 13.6467 0.806491 13.3076 1.05654 13.0575C1.30659 12.8075 1.64573 12.667 1.99935 12.667H5.99935C6.35297 12.667 6.69211 12.8075 6.94216 13.0575C7.19221 13.3076 7.33268 13.6467 7.33268 14.0003C7.33268 14.3539 7.19221 14.6931 6.94216 14.9431C6.69211 15.1932 6.35297 15.3337 5.99935 15.3337H1.99935C1.64573 15.3337 1.30659 15.1932 1.05654 14.9431C0.806491 14.6931 0.666016 14.3539 0.666016 14.0003ZM20.666 14.0003C20.666 13.6467 20.8065 13.3076 21.0565 13.0575C21.3066 12.8075 21.6457 12.667 21.9993 12.667H25.9993C26.353 12.667 26.6921 12.8075 26.9422 13.0575C27.1922 13.3076 27.3327 13.6467 27.3327 14.0003C27.3327 14.3539 27.1922 14.6931 26.9422 14.9431C26.6921 15.1932 26.353 15.3337 25.9993 15.3337H21.9993C21.6457 15.3337 21.3066 15.1932 21.0565 14.9431C20.8065 14.6931 20.666 14.3539 20.666 14.0003ZM9.28602 18.7137C9.53598 18.9637 9.6764 19.3028 9.6764 19.6563C9.6764 20.0099 9.53598 20.349 9.28602 20.599L6.45535 23.4297C6.33235 23.557 6.18523 23.6586 6.02256 23.7285C5.85988 23.7983 5.68492 23.8351 5.50788 23.8367C5.33084 23.8382 5.15527 23.8045 4.99141 23.7374C4.82755 23.6704 4.67868 23.5714 4.55349 23.4462C4.4283 23.321 4.32929 23.1721 4.26225 23.0083C4.19521 22.8444 4.16148 22.6688 4.16301 22.4918C4.16455 22.3148 4.20133 22.1398 4.27121 21.9771C4.34109 21.8144 4.44267 21.6673 4.57002 21.5443L7.40068 18.7137C7.65072 18.4637 7.9898 18.3233 8.34335 18.3233C8.6969 18.3233 9.03598 18.4637 9.28602 18.7137ZM18.7127 18.7137C18.9627 18.4637 19.3018 18.3233 19.6554 18.3233C20.0089 18.3233 20.348 18.4637 20.598 18.7137L23.426 21.5417C23.6689 21.7931 23.8033 22.1299 23.8002 22.4795C23.7972 22.8291 23.657 23.1635 23.4098 23.4108C23.1626 23.658 22.8281 23.7982 22.4786 23.8012C22.129 23.8043 21.7922 23.6699 21.5407 23.427L18.714 20.6003C18.59 20.4765 18.4917 20.3294 18.4246 20.1676C18.3575 20.0057 18.323 19.8322 18.323 19.657C18.323 19.4818 18.3575 19.3083 18.4246 19.1464C18.4917 18.9845 18.59 18.8375 18.714 18.7137H18.7127ZM13.9993 20.667C14.353 20.667 14.6921 20.8075 14.9422 21.0575C15.1922 21.3076 15.3327 21.6467 15.3327 22.0003V26.0003C15.3327 26.3539 15.1922 26.6931 14.9422 26.9431C14.6921 27.1932 14.353 27.3337 13.9993 27.3337C13.6457 27.3337 13.3066 27.1932 13.0565 26.9431C12.8065 26.6931 12.666 26.3539 12.666 26.0003V22.0003C12.666 21.6467 12.8065 21.3076 13.0565 21.0575C13.3066 20.8075 13.6457 20.667 13.9993 20.667Z"
      fill="url(#paint0_radial_12581_25079)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_12581_25079"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(6.66602 4.3707) rotate(73.4898) scale(25.8047 25.6754)"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#14E7F4" />
      </radialGradient>
    </defs>
  </svg>
);

export default function VoiceButton({
  isRecording,
  onClick = () => {},
  marginBottom,
  isLoadingWebSocket,
  handlePauseStream,
  volumeLevels,
  isAudioPlaying,
}) {
  // const [showTooltip, setShowTooltip] = useState(false);
  const [volumeLevel, setVolumeLevel] = useState(0);

  const handleButtonClick = useCallback(() => {
    if (isAudioPlaying) return; // Nếu isAudioPlaying là true thì không làm gì cả
  
    if (isRecording) {
      handlePauseStream();
    } else {
      onClick();
    }
  }, [isRecording, handlePauseStream, onClick, isAudioPlaying]);

  useEffect(() => {
    if (volumeLevels && volumeLevels.length > 0 && !isAudioPlaying) {
      const maxVolume = Math.max(...volumeLevels);
      setVolumeLevel(maxVolume / 255); // Normalize the volume level to a range of 0 to 1
    }
  }, [volumeLevels, isAudioPlaying]);

  const getTextMessage = () => {
    if (isLoadingWebSocket) return "Activating Mic…";
    if (isRecording) return ""; //Mic Activated. Speak Now... Press to Pause
    return "Activate Microphone";
  };

  return (
    <>
      {/* Nêú trường hợp  show MicDisabled thì không show text*/}
      {!isAudioPlaying && <Text>{getTextMessage()}</Text>}
      <Box marginBottom={marginBottom}>
        <PulseWrapper
          onClick={handleButtonClick}
          isRecording={isRecording}
          isLoadingWebSocket={isLoadingWebSocket}
          volumeLevel={volumeLevel}
        >
          <ButtonWrapper
            isRecording={isRecording && !isLoadingWebSocket && !isAudioPlaying}
            isLoadingWebSocket={isLoadingWebSocket}
            volumeLevel={volumeLevel}
            // onMouseOver={() => !isRecording && setShowTooltip(true)}
            // onMouseOut={() => !isRecording && setShowTooltip(false)}
          >
            {!isAudioPlaying && <BackgroundEffect />}
            {/* {!isLoadingWebSocket && !isRecording && (
              <Tooltip show={showTooltip}>
                Press once to activate the microphone. Speak, then stop speaking
                to hear the response. <br /> Wait for the response to finish
                before speaking again.
              </Tooltip>
            )} */}
            {isLoadingWebSocket ? (
              <LoaderContainer>
                <CustomLoader />
              </LoaderContainer>
            ) : isAudioPlaying ? (
              <MicDisabled src={DisabledVoice} alt="Voice Disabled" /> // Dùng icon DisabledVoice
            ) : isRecording ? (
              <PauseStream src={PauseStreamIcon} alt="Pause Recording" />
            ) : (
              <MicStream
                src={StartStreamIcon}
                alt="Start Recording"
                isRecording={isRecording}
              />
            )}
          </ButtonWrapper>
        </PulseWrapper>
      </Box>
    </>
  );
}
